/**
 * Continue with LinkedIn, beside Continue with Google (api routes/auth.js,
 * Sign In with LinkedIn using OpenID Connect). Shown only when the server has
 * the platform LinkedIn app, so a page never offers a door that does not open.
 */
import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { api } from '@/lib/api';

let providersOnce = null;
export function useSigninProviders() {
  const [p, setP] = useState(null);
  useEffect(() => {
    providersOnce = providersOnce || Promise.resolve().then(() => api.get('/api/auth/providers'))
      .then((r) => (r && r.data) || { google: true, linkedin: false }).catch(() => ({ google: true, linkedin: false }));
    let live = true;
    providersOnce.then((v) => { if (live) setP(v); });
    return () => { live = false; };
  }, []);
  return p;
}

export function LinkedInAuthButton({ label = 'Continue with LinkedIn', onError }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.get('/api/auth/linkedin/start');
      window.location.assign(data.auth_url);
    } catch (err) {
      setBusy(false);
      onError?.(err.response?.data?.error || 'LinkedIn sign-in is unavailable right now.');
    }
  };
  // The same white button as Google's, with LinkedIn's own blue mark.
  return (
    <button type="button" onClick={go} disabled={busy}
      className="flex h-12 w-full items-center justify-center gap-3 rounded-xl border border-border bg-white text-[15.5px] font-medium text-[#1F1F1F] transition-colors hover:bg-muted/40 disabled:opacity-60 dark:border-[#8E918F] dark:bg-[#131314] dark:text-[#E3E3E3] dark:hover:bg-[#1E1F20]">
      {busy ? <Loader2 className="size-4 animate-spin" /> : (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
          <rect width="24" height="24" rx="4" fill="#0A66C2" />
          <path fill="#fff" d="M7.1 9.6h2.4v7.7H7.1zM8.3 5.8a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8zM11 9.6h2.3v1.1h.03c.32-.6 1.1-1.24 2.27-1.24 2.43 0 2.88 1.6 2.88 3.68v4.2h-2.4v-3.72c0-.89-.02-2.03-1.24-2.03-1.24 0-1.43.97-1.43 1.97v3.78H11z" />
        </svg>
      )}
      <span>{label}</span>
    </button>
  );
}

export default LinkedInAuthButton;
